"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    launchAssessmentModal: {
        launchHeader: "You are Launching '{{title}}' for '{{section}}'",
        launchBody: 'All assigned students will be able to see and interact with the Assessment. Are you sure you want to Launch?',
        cancelButton: 'NO, CANCEL',
        submitButton: 'YES, LAUNCH',
    },
};
